import type { AppNotification } from '../types/notifications'
import { isUnread } from '../services/notifications'

export type NotificationSectionId = 'unread' | 'read'

export interface NotificationSection {
  id: NotificationSectionId
  label: string
  items: AppNotification[]
}

/** Split inbox items into ulæste / tidligere groups (preserves API order within each). */
export function notificationSections(items: AppNotification[]): NotificationSection[] {
  const unread = items.filter(isUnread)
  const read = items.filter((n) => !isUnread(n))
  const sections: NotificationSection[] = []

  if (unread.length > 0) {
    sections.push({
      id: 'unread',
      label: unread.length === 1 ? 'Ulæst' : `Ulæste (${unread.length})`,
      items: unread,
    })
  }
  if (read.length > 0) {
    sections.push({
      id: 'read',
      label: 'Tidligere',
      items: read,
    })
  }

  return sections
}

export function notificationTitleClass(unread: boolean, compact = false): string {
  const base = compact ? 'text-sm truncate' : 'font-serif text-base block'
  return unread
    ? `${base} font-semibold text-ink`
    : `${base} font-normal text-ink-600`
}

export function notificationSummaryClass(unread: boolean, compact = false): string {
  const size = compact ? 'text-xs' : 'text-sm'
  return unread
    ? `${size} text-ink-600 mt-0.5 line-clamp-2`
    : `${size} text-ink-500 mt-0.5 line-clamp-2`
}

export function formatNotificationWhen(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString('da-DK', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
